import classes from './Circle.module.css';

function Circles() {
  return (
    <>
      <div className={classes.circle1} />
      <div className={classes.circle2} />
      <div className={classes.circle3} />
      <div className={classes.circle4} />
    </>
  );
}

export default Circles;
